export default "__VITE_ASSET__DNnN3zca__"